import { IAction } from "UI/UI.Controls/Actions/IAction";
import { Event } from "../../../../../Global/Base/Events";
import { IEnabledVisualControl } from "../../../../UI.BaseControls/ControlInterfaces";
import { DropDownMenuItem } from "../../../../UI.Controls/DropDownMenu/DropDownMenuItem";
import { Control } from "../../Controls/Control";
import { IGenericControl } from "../../Controls/ControlInterfaces";
import { MultiActionToolbarButton } from "./MultiActionToolbarButton";
/**
 * Interface pro toolbarbutton
 * @generateInstanceClass
 */
export interface IToolbarButton extends IGenericControl, IEnabledVisualControl {
    visibilityChanged: Event<Control, boolean>;
    enabled: boolean;
    enabledVisual: boolean;
    visible: boolean;
    dropDownMenuItem: DropDownMenuItem;
    action: IAction;
    changeVisibilityNotificationDot(isVisible: boolean, captionLocKey?: string): void;
}

export class IToolbarButton {
    private static _properties = ["visibilityChanged", "element", "dropDownMenuItem", "visible", "action", "enabled", "enabledVisual"];
    private static _methods = ["changeVisibilityNotificationDot"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
        !this._methods.some(value => typeof instance[value] !== "function");
    }
}

/**
 * Rozhraní pro toolbar tlačítko pro MultiObjectAkce
 * @includeToDoc
 */
export interface IMultiActionToolbarButton extends IToolbarButton {
    isMultiSelect: boolean;
    enabledVisualChanged: Event<MultiActionToolbarButton, boolean>;
    enabledVisual: boolean;
    dispose: () => void;
}

export class IMultiActionToolbarButton {
    private static _properties = ["isMultiSelect", "enabledVisualChanged", "enabledVisual", "dispose"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) && instance instanceof IToolbarButton;
    }
}
